export const vinantic_french_traduction = {
  title: "Vinantic",
  description: {
    head: "Bienvenue sur Vinantic, un catalogue personnel dédié à ma collection privée de vins millésimés, de 1940 à nos jours.",
    content_1:
      "Chaque bouteille raconte une histoire, un moment précieux, une année particulière. Ce catalogue répertorie des millésimes rares, témoins des années passées, que je collectionne comme de véritables œuvres d'art.",
    content_2:
      "Cette collection rassemble des vins rouges corsés, des vins blancs frais ou liquoreux, en passant par des rosés fruités. Ce site est un catalogue personnel et ne constitue en aucun cas un site de vente ou une activité commerciale. Les descriptifs des bouteilles sont indicatifs et peuvent contenir des inexactitudes.",
  },
  warnings: {
    no_wines_available: "Aucun millésime n'est répertorié",
  },
  banner: {
    upload_pdf: "Télécharger le catalogue au format PDF.",
    sorted_list: "La liste ci-dessous a été triées.",
    no_sorted_list: "La liste ci-dessous n'a pas été triées.",
    no_available_list: "Aucune bouteille n'est répertoriée.",
    available_list: "{{ totalWines }} bouteilles répertoriées. ",
    page_info: "Vous êtes sur la page {{currentPage}} du catalogue. "
  },
  bottle: {
    castle: "Château",
    stock: "Quantité :",
    price: "Valeur indicative :",
    unit: "€",
    quality: "Qualité : ",
    description: "Description :",
    ref: "Référence :",
  },
  general: {
    loadingMessage: "En cours de chargement...",
    errorMessage: "Une erreur est survenue"
  }
};
